import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { StateChange } from 'ng-lazyload-image';
import * as jquery from 'jquery';

declare var require: any;

@Component({
  selector: 'series-navigation',
  templateUrl: './series-navigation.component.html',
  styleUrls: ['./series-navigation.component.scss']
})
export class SeriesNavigationComponent implements OnInit {

  series: any;
  error = false;
  loading = false;
  preloaderImage = require('../../../../assets/images/loader-big.svg');
  seriesId: number;
  moduleId: number;
  videosActive: any;
  exerciseActive: any;
  quizActive: any;
  summaryActive: any;
  scrollHeight = 0;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private pageTitleService: Title
  ) { }

  ngOnInit(): void {
    this.setPageTitle();
    this.getIds();
    this.getRouteQueryParams();

    // Enables to reload current route
    this.router.routeReuseStrategy.shouldReuseRoute = () => {
      return false;
    };

  }

  getRouteQueryParams() {
    this.videosActive = this.route.snapshot.queryParamMap.get('video_active');
    this.exerciseActive = this.route.snapshot.queryParamMap.get('exercise_active');
    this.quizActive = this.route.snapshot.queryParamMap.get('quiz_active');
    this.summaryActive = this.route.snapshot.queryParamMap.get('summary_active');
  }

  getIds() {
    this.seriesId = this.route.snapshot.params.seriesId;
    this.moduleId = this.route.snapshot.params.moduleId;
  }

  setPageTitle() {
    this.pageTitleService.setTitle(this.route.snapshot.data.title || 'Videos');
  }

  scrollToSpecificModule() {
    const sideNavContainer: HTMLElement = document.getElementById('side-nav');
    sideNavContainer?.classList.remove('d-none');

    const moduleContainer: HTMLElement = document.getElementById('module_' + this.seriesId + '_' + this.moduleId);
    moduleContainer?.classList.add('show');

    const moduleImageContainer: HTMLElement = document.getElementById('module_image_' + this.seriesId + '_' + this.moduleId);

    const moduleTitleContainer: HTMLElement = document.getElementById('module_title_' + this.seriesId + '_' + this.moduleId);
    moduleTitleContainer?.classList.add('add-border-bottom');

    const moduleTitleIcon: HTMLElement = document.getElementById('module_title_icon_' + this.seriesId + '_' + this.moduleId);
    moduleTitleIcon?.classList.remove('fa-chevron-down');
    moduleTitleIcon?.classList.add('fa-chevron-up');

    const scrollTop = (moduleImageContainer?.getBoundingClientRect().top - sideNavContainer?.getBoundingClientRect().top);

    if (scrollTop > this.scrollHeight) {
      this.scrollHeight = scrollTop;
      this.scrollToTarget(scrollTop, sideNavContainer);
    } else {
      this.scrollToTarget(this.scrollHeight, sideNavContainer);
    }

    // Sets video link to active
    if ((this.videosActive as boolean)) {
      const videoLink: HTMLElement = document.getElementById('link_video_' + this.seriesId + '_' + this.moduleId);
      videoLink?.classList.add('active');
    }

    // Sets exercise link to active
    if ((this.exerciseActive as boolean)) {
      const exerciseLink: HTMLElement = document.getElementById('link_exercise_' + this.seriesId + '_' + this.moduleId);
      exerciseLink?.classList.add('active');
    }

    // Sets quiz link to active
    if ((this.quizActive as boolean)) {
      const quizLink: HTMLElement = document.getElementById('link_quiz_' + this.seriesId + '_' + this.moduleId);
      quizLink?.classList.add('active');
    }

    // Sets summary link to active
    if ((this.summaryActive as boolean)) {
      const summaryLink: HTMLElement = document.getElementById('link_summary_' + this.seriesId + '_' + this.moduleId);
      summaryLink?.classList.add('active');
    }

  }

  reloadPage(seriesId: number, moduleId: number) {
    this.router.navigate(['/user/videos/' + seriesId + '/' + moduleId], {
      queryParams: {
        video_active: true
      }
    });
  }

  showModuleLinks(seriesId: number, moduleId: number) {
    jquery('#module_' + seriesId + '_' + moduleId).slideToggle();
    setTimeout(() => {
      const isCollapsed = jquery('#module_' + seriesId + '_' + moduleId).is(':visible');
      const moduleTitleContainer: HTMLElement = document.getElementById('module_title_' + seriesId + '_' + moduleId);
      const moduleTitleIcon: HTMLElement = document.getElementById('module_title_icon_' + seriesId + '_' + moduleId);

      if (isCollapsed) {
        moduleTitleContainer?.classList.add('add-border-bottom');

        moduleTitleIcon?.classList.remove('fa-angle-down');
        moduleTitleIcon?.classList.add('fa-angle-up');
      } else {
        moduleTitleContainer?.classList.remove('add-border-bottom');
        moduleTitleIcon?.classList.remove('fa-angle-up');
        moduleTitleIcon?.classList.add('fa-angle-down');
      }
    }, 500);
  }

  moduleImageCallback(event: StateChange, seriesId: number, moduleId: number) {
    switch (event.reason) {
      case 'setup':
        // The lib has been instantiated but we have not done anything yet.
        const imageContainerOnInit: HTMLElement = document.getElementById('module_image_' + seriesId + '_' + moduleId);
        imageContainerOnInit?.classList.add('module-image-loading');
        break;
      case 'observer-emit':
        // The image observer (intersection/scroll observer) has emit a value so we
        // should check if the image is in the viewport.
        // `event.data` is the event in this case.
        break;
      case 'start-loading':
        // The image is in the viewport so the image will start loading
        break;
      case 'mount-image':
        // The image has been loaded successfully so lets put it into the DOM
        break;
      case 'loading-succeeded':
        // The image has successfully been loaded and placed into the DOM
        const imageContainerAfterInit: HTMLElement = document.getElementById('module_image_' + seriesId + '_' + moduleId);
        imageContainerAfterInit?.classList.remove('module-image-loading');
        imageContainerAfterInit?.classList.add('module-image-fit');

        // Module Points
        const moduleBadgePointsContainer: HTMLElement = document.getElementById('module_badge_points_' + seriesId + '_' + moduleId);
        moduleBadgePointsContainer?.classList.remove('d-none');
        moduleBadgePointsContainer?.classList.add('d-inline');

        // Module Video Status
        const moduleBadgeVideoContainer: HTMLElement = document.getElementById('module_badge_video_' + seriesId + '_' + moduleId);
        moduleBadgeVideoContainer?.classList.remove('d-none');
        moduleBadgeVideoContainer?.classList.add('d-inline');

        // Module Video Duration
        const moduleBadgeVideoDurationContainer: HTMLElement = document.getElementById('module_badge_video_duration_' + seriesId + '_' + moduleId);
        moduleBadgeVideoDurationContainer?.classList.remove('d-none');
        moduleBadgeVideoDurationContainer?.classList.add('d-inline');

        // Module Play Button
        const playButtonContainer: HTMLElement = document.getElementById('module_play_' + seriesId + '_' + moduleId);
        playButtonContainer?.classList.add('badge-play');

        break;
      case 'loading-failed':
        // The image could not be loaded for some reason.
        // `event.data` is the error in this case
        break;
      case 'finally':
        // The last event before cleaning up
        break;
    }
  }

  private scrollToTarget(target: any, containerEl: HTMLElement) {
    if (containerEl != null) {
      const isElement = target && target.nodeType === 1;
      const isNumber = Object.prototype.toString.call(target) === '[object Number]';

      if (isElement) {
        containerEl.scrollTop = target.offsetTop;
      } else if (isNumber) {
        containerEl.scrollTop = target;
      } else if (target === 'bottom') {
        containerEl.scrollTop = containerEl.scrollHeight - containerEl.offsetHeight;
      } else if (target === 'top') {
        containerEl.scrollTop = 0;
      }
    }
  }

}
